import TourPage from "@/components/TourPage";

export default function PrimatesWildlife8Day() {
  return (
    <TourPage
      tourId="uganda/primates-wildlife-8-day"
      title="8-Day Primates and Wildlife Safaris"
      duration="8 Days / 7 Nights"
      price="Contact for price"
      image="/gorillatrekking.png"
      description="Combine primate encounters with classic wildlife viewing in this comprehensive 8-day safari through Uganda's most diverse national parks."
      itinerary={[
        {
          day: 1,
          title: "Arrival and Entebbe",
          description: "Welcome to Uganda.",
          activities: [
            "Airport pickup",
            "Transfer to hotel",
            "Safari briefing",
            "Evening at leisure"
          ],
          accommodation: "Protea Hotel or similar",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Kibale Forest National Park",
          description: "Journey to the primate capital.",
          activities: [
            "Drive to Kibale Forest",
            "Afternoon botanical walk",
            "Visit local communities"
          ],
          accommodation: "Primate Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Chimpanzee Tracking",
          description: "Track our closest relatives.",
          activities: [
            "Chimpanzee tracking",
            "Bigodi Wetland Sanctuary visit",
            "Night walk option"
          ],
          accommodation: "Primate Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Queen Elizabeth National Park",
          description: "Transfer to Queen Elizabeth NP.",
          activities: [
            "Drive to Queen Elizabeth",
            "Game drive",
            "Boat cruise on Kazinga Channel"
          ],
          accommodation: "Mweya Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Ishasha Sector",
          description: "Search for tree-climbing lions.",
          activities: [
            "Game drive in Ishasha",
            "Tree-climbing lions search",
            "Drive to Bwindi"
          ],
          accommodation: "Bwindi Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 6,
          title: "Gorilla Trekking",
          description: "Trek to meet the mountain gorillas.",
          activities: [
            "Gorilla trekking briefing",
            "Trek to meet gorilla family",
            "One hour with gorillas",
            "Evening relaxation"
          ],
          accommodation: "Bwindi Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 7,
          title: "Lake Mburo National Park",
          description: "Transfer to Lake Mburo.",
          activities: [
            "Drive to Lake Mburo",
            "Afternoon boat ride",
            "Evening game drive"
          ],
          accommodation: "Mihingo Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 8,
          title: "Return to Entebbe",
          description: "Final activities and departure.",
          activities: [
            "Morning nature walk",
            "Drive back to Entebbe",
            "Departure"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "Gorilla permit",
        "Chimpanzee permit",
        "Park entrance fees",
        "4x4 safari vehicle",
        "English-speaking guide",
        "Accommodation as listed",
        "Meals as specified",
        "Game drives",
        "Boat cruises"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips and gratuities",
        "Drinks and beverages",
        "Optional activities"
      ]}
    />
  );
}
